@switch (question?.questionSubType) { @case (questionSubType.SHORT_TEXT) {
<div class="question-content-width" >
  <app-input-text placeholder="Enter Your Response"
  [size]="'small'"
  (click)="$event.stopPropagation()"></app-input-text>
</div>
} 

@case (questionSubType.FULL_NAME) {
<div class="question-content-width">
  <app-input-text
   placeholder="Enter Your Response"
   [size]="'small'"
   (click)="$event.stopPropagation()"></app-input-text>
</div>
} @case (questionSubType.LONG_TEXT) {
<div class="question-content-width">
  <app-textarea
    placeholder="Enter Your Response"
    [rows]="3"
    (click)="$event.stopPropagation()"
  ></app-textarea>
</div>
} @case (questionSubType.NUMBERS) {
<div class="question-content-width">
  <app-number
   placeholder="Enter Your Response"
   [size]="'small'"
   (click)="$event.stopPropagation()"></app-number>
</div>
} @case (questionSubType.PHONE_NUMBER) {
<div class="question-content-width">
  <app-mobile-number
    placeholder="Enter Your Response"
    [size]="'small'"
    (click)="$event.stopPropagation()"
  ></app-mobile-number>
</div>
} @case (questionSubType.EMAIL) {
<div class="question-content-width">
  <app-input-text placeholder="Enter Your Response"
   [size]="'small'"
   (click)="$event.stopPropagation()"></app-input-text>
</div>
} @case (questionSubType.WEBSITE_URL) {
<div class="question-content-width">
  <app-input-text placeholder="Enter Your Response"
   [size]="'small'"
   (click)="$event.stopPropagation()"></app-input-text>
</div>
} @case (questionSubType.CALENDAR) {
<div class="question-content-width">
  <app-date-picker date="datetime-local"
   [size]="'small'"
   (click)="$event.stopPropagation()"></app-date-picker>
</div>
 }
}